import type { Finding } from '@/model/Agent.model';
import type { FC } from 'react';
import styles from './sendResults.module.scss';
import { sourceOf } from './sendReport';

// Chip's blue and gray schemes, drawn on a span: Chip's root is a div, and this badge sits inside
// buttons and running text, which may only hold phrasing content.
const colourClasses = {
  check: 'blue b--lightest-blue bg-lightest-blue',
  ai: 'near-black b--moon-gray bg-moon-gray',
} as const;

interface SendFindingSourceProps {
  finding: Pick<Finding, 'origin'>;
  className?: string;
}

/**
 * Badge naming where a SEND finding came from, "Validation check" or "Benchling In Vivo AI", as
 * {@link sourceOf} decides.
 */
const SendFindingSource: FC<SendFindingSourceProps> = ({ finding, className = '' }) => {
  const source = sourceOf(finding);
  return (
    <span
      className={`f7 lh-title dib br2 ba ph2 pv1 ${styles.nowrap} ${colourClasses[source.key]} ${className}`}
      data-test-element="finding-source"
      data-test-key={source.key}
    >
      {source.label}
    </span>
  );
};

export default SendFindingSource;
